import type { ReactNode } from 'react';

export type TagTone = 'ink' | 'blue';
export type TagSize = 'xs' | 'sm';

const TONE_CLASS: Record<TagTone, string> = {
  ink: 'bg-brand-ink',
  blue: 'bg-brand-badge',
};

const SIZE_CLASS: Record<TagSize, string> = {
  xs: 'rounded-md px-1.5 text-micro leading-4',
  sm: 'rounded-md px-2 py-0.5 text-caption leading-4',
};

/** Pinned into a card's top-left corner; the radii follow the card's own rounded-xl corner. */
const CORNER_CLASS = 'absolute left-0 top-0 z-[1] rounded-br-lg rounded-tl-xl px-2.5 py-1 text-micro tracking-wider';

/**
 * Small solid label with white text — product badge ("Novinka"), "Ukončeno", category labels.
 * `xs` sits inline next to a product code, `sm` stands on its own or over a photo (position it via `className`).
 */
export function Tag({
  tone = 'ink',
  size = 'sm',
  uppercase = false,
  corner = false,
  className = '',
  children,
}: {
  tone?: TagTone;
  size?: TagSize;
  uppercase?: boolean;
  /** Card-corner layout; overrides `size`. */
  corner?: boolean;
  className?: string;
  children: ReactNode;
}) {
  const layout = corner ? CORNER_CLASS : `${SIZE_CLASS[size]} ${uppercase ? 'tracking-wide' : ''}`;

  return (
    <span
      className={`inline-block whitespace-nowrap align-middle font-normal text-white ${TONE_CLASS[tone]} ${layout} ${
        uppercase ? 'uppercase' : ''
      } ${className}`}
    >
      {children}
    </span>
  );
}
